/**
 * Stablecoin base token list
 * Used for filtering and identifying stablecoin currencies
 */
export const STABLECOIN_BASE_TOKENS: readonly string[] = ['USDT', 'USDC']

/**
 * Check if a currency code is a stablecoin base token
 */
export const isStablecoinBaseToken = (code: string): boolean => {
  return STABLECOIN_BASE_TOKENS.includes(code)
}
